module.exports = __webpack_public_path__ + "static/media/award2.5aad7df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/award2.png
// module id = 1346
// module chunks = 0